import * as React from 'react';
import { useTranslation } from 'react-i18next';

const ModuleStatus = ({ published, small }) => {
  const { t } = useTranslation();

  const classNames = ['Status', `Status--state-${published ? 'published' : 'concept'}`];
  if (small) classNames.push('Status--small');

  const label = published
    ? t('common:status_live')
    : t('common:status_draft');

  return (
    <div className={classNames.join(' ')}>{!small && label}</div>
  );
};

export default ModuleStatus;
